import { Directive, HostListener } from '@angular/core';
import { DebounceDirective } from './debounce.directive';

/**
 * Debounces 'ngModelChange' event.
 */
@Directive({
  selector: '[mfpNgModelChangeDebounce]',
  exportAs: 'ngModelChangeDebounce'
})
export class NgModelChangeDebounceDirective extends DebounceDirective {

  constructor() {
    super();
  }

  @HostListener('ngModelChange', ['$event'])
  public onNgModelChange(event: any): void {
    this.debounceEvent(event);
  }
}
